import Http from 'services/utils/http';

class CompanyInfoService {
    constructor() {
        this.baseUrl = '/api/rest/v1/company';
        this.cache = {};
    }

    // returns the wanted fields from the cache as an object
    getOnlySelectedFieldsFromCache(fields) {
        return fields.reduce((obj, field) => {
            obj[field] = this.cache[field];
            return obj;
        }, {});
    }

    async getCompanyInfo(fields = []) {
        const params = fields.filter((field) => field && !this.cache[field]);

        // send request. if no params are set, meaning all from cache, so resolve from cache
        if (params.length > 0) {
            const url = `${this.baseUrl}?fields=${params.join(',')}`;

            try {
                const response = await Http.get(url);
                const company = response.data.companies[0];
                // update cache with new fields
                this.cache = { ...this.cache, ...company };
                return this.getOnlySelectedFieldsFromCache(fields);
            } catch (error) {
                return error && error.data && error.data.error;
            }
        } else {
            return this.getOnlySelectedFieldsFromCache(fields);
        }
    }
}

export default new CompanyInfoService();
